import { render, staticRenderFns } from "./ExceptionCollection.vue?vue&type=template&id=4fe62f25&scoped=true&"
import script from "./ExceptionCollection.vue?vue&type=script&lang=js&"
export * from "./ExceptionCollection.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionCollection.vue?vue&type=style&index=0&id=4fe62f25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe62f25",
  null
  
)

export default component.exports